<template>
  <div class="admin-prev-next-wrapper d-flex align-items-center" v-if="entry_id">
    <div class="mr-2">
      <a href="/search" class="admin-prev-action-wrapper btn text-center d-flex justify-content-center">
        <div class="small upper mt-0 line-height-24">Return to List</div>
      </a>
    </div>
    <div class="mr-2">
      <a v-if="prevUrl" :href="'/entry/'+prevUrl" class="admin-prev-action-wrapper btn text-center d-flex justify-content-center">
        <caretleft class="margin-auto svg-white"></caretleft>
        <div class="small upper mt-1">Previous Submission</div>
      </a>
    </div>
    <div class="">
      <a v-if="nextUrl" :href="'/entry/'+nextUrl" class="admin-next-action-wrapper btn text-center d-flex justify-content-center">
        <div class="small upper mt-1">Next Submission</div>
        <caretright class="margin-auto svg-white"></caretright>
      </a>
    </div>
  </div>
</template>

<script>
import caretleft from './icons/caret_left.vue';
import caretright from './icons/caret_right.vue';
import play from './icons/play.vue';

export default {
  name: "EntryFormNextPrevAdmin",
  components: {caretleft, caretright, play},
  props: ['entry_id', 'user_id'],
  data() {
    return {
      pluck_ids: [],
      nextUrl: '',
      prevUrl: ''
    }
  },
  mounted() {
    if (localStorage.getItem('CTA-admin-next-prev')) {
      this.pluck_ids = localStorage.getItem('CTA-admin-next-prev');
      this.prevNextUrls();
    }
  },
  methods: {
    prevNextUrls: function () {
      let app = this;
      if (app.pluck_ids && app.pluck_ids.length > 0) {
        let indexList = app.pluck_ids.split(',');
        let currentEntryIndex = indexList.indexOf(app.entry_id);
        let prev_index = Number(currentEntryIndex) - Number(1);
        let next_index = Number(currentEntryIndex) + Number(1);

        if (prev_index >= 0) {
          app.prevUrl = indexList[prev_index];
        }

        if (next_index < indexList.length) {
          app.nextUrl = indexList[next_index];
        }
      }
    },
    clearSubmitterCache: function(ev) {
      localStorage.removeItem('CTA-history-search');
      localStorage.removeItem('CTA-history-search-status');
      localStorage.removeItem('CTA-history-search-filestatus');
      localStorage.removeItem('CTA-history-search-type');
      localStorage.removeItem('CTA-history-search-sort');
      localStorage.removeItem('CTA-history-search-sort-order');
      localStorage.removeItem('CTA-history-search-num');
      localStorage.removeItem('CTA-history-search-page');
      window.location = $(ev.target).attr('href')
    }
  }
}
</script>
